import rmskincareAPI from '../utils/rmskincareAPI'

const salaryApi = {
  getAllSalary: async () => {
    const result = await rmskincareAPI.get(
      `/salary/list?storeId=1`
    )
    return result.data.data
  },

  addOrEditSalary:async(requestBody)=>{
    const result =await rmskincareAPI.post(
      `/salary/save`,requestBody
    )
    return result.data.data
  },


}

export default salaryApi
